import { render, staticRenderFns } from "./StepNeeds.vue?vue&type=template&id=1edc8476&scoped=true"
import script from "./StepNeeds.vue?vue&type=script&lang=js"
export * from "./StepNeeds.vue?vue&type=script&lang=js"
import style0 from "./StepNeeds.vue?vue&type=style&index=0&id=1edc8476&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc8476",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1edc8476')) {
      api.createRecord('1edc8476', component.options)
    } else {
      api.reload('1edc8476', component.options)
    }
    module.hot.accept("./StepNeeds.vue?vue&type=template&id=1edc8476&scoped=true", function () {
      api.rerender('1edc8476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/steps/StepNeeds.vue"
export default component.exports